import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { formatPhone } from '@rad/utility/formatting';
import CInput from './input';
import CSelect from './select';
const PHONE_SMS_SUBKINDS = ['mobile', 'unknown'];
export default (props) => {
    var _a;
    const items = React.useMemo(() => {
        const kind = props.mode === 'email' ? 'email' : 'phone';
        const filtered = props.contacts.filter((c) => c.kind === kind);
        const narrowed = props.mode === 'sms' ? filtered.filter((c) => PHONE_SMS_SUBKINDS.includes(c.subkind)) : filtered;
        const source = narrowed.length > 0 ? narrowed : filtered;
        return source.map((c) => {
            const shown = kind === 'phone' ? formatPhone(c.value) : c.value;
            const subkindTag = kind === 'phone' && c.subkind !== 'unknown' ? ` (${c.subkind})` : '';
            const labelTag = c.label ? ` - ${c.label}` : '';
            return { 'value': c.value, 'title': `${shown}${subkindTag}${labelTag}` };
        });
    }, [props.contacts, props.mode]);
    if (items.length === 0) {
        return _jsx(CInput, { type: props.mode === 'email' ? 'email' : 'tel', value: props.value, onChange: props.onChange, children: props.children });
    }
    // Override input appears only when the current value doesn't match a known contact.
    const digitsOnly = (s) => (s || '').replace(/\D/g, '');
    const compare = props.mode === 'email'
        ? (a, b) => a.trim().toLowerCase() === b.trim().toLowerCase()
        : (a, b) => digitsOnly(a) === digitsOnly(b);
    const matchedValue = ((_a = items.find((x) => compare(x.value, props.value))) === null || _a === void 0 ? void 0 : _a.value) || '';
    const showOverride = !matchedValue;
    return _jsxs(_Fragment, { children: [_jsx(CSelect, { items: items, valuef: (x) => x.value, titlef: (x) => x.title, value: matchedValue, onChange: (v) => props.onChange(v ? (props.mode === 'email' ? v : formatPhone(v)) : ''), emptyTitle: "Other...", children: props.children }), showOverride && _jsx(CInput, { type: props.mode === 'email' ? 'email' : 'tel', value: props.value, onChange: props.onChange, children: props.mode === 'email' ? 'Email' : 'Phone' })] });
};
